import { createReducer, Reducer } from '@reduxjs/toolkit'

import { AuthActionTypes } from '@store/auth'
import { returnSecondIfDeepEqual } from '@utils'
import { applyAudienceInsightFilters } from './actions'
import { AudienceInsightsActionTypes, IIAudienceInsightsState } from './types'

const initialState: IIAudienceInsightsState = {
  audienceInsightsByIdentityId: {},
  brandConnectAudienceInsightsById: {},
  filters: {},
  errors: undefined,
  isFetching: false,
}

const legacyReducer: Reducer<IIAudienceInsightsState> = (state = initialState, action) => {
  switch (action.type) {
    case AudienceInsightsActionTypes.FETCH_REQUEST: {
      const { identityId } = action.payload as { identityId: number }
      const updatedState = {
        ...state.audienceInsightsByIdentityId,
        [identityId]: undefined,
      }

      return {
        ...state,
        audienceInsightsByIdentityId: returnSecondIfDeepEqual(
          updatedState,
          state.audienceInsightsByIdentityId,
        ),
        isFetching: true,
      }
    }
    case AudienceInsightsActionTypes.FETCH_SUCCESS: {
      const { identityId, audienceInsights } = action.payload
      return {
        ...state,
        audienceInsightsByIdentityId: returnSecondIfDeepEqual(
          {
            ...state.audienceInsightsByIdentityId,
            [identityId]: audienceInsights,
          },
          state.audienceInsightsByIdentityId,
        ),
        isFetching: false,
        errors: undefined,
      }
    }
    case AudienceInsightsActionTypes.FETCH_ERROR: {
      return {
        ...state,
        isFetching: false,
        errors: action.payload,
      }
    }
    case AudienceInsightsActionTypes.BRAND_CONNECT_FETCH_SUCCESS: {
      const { submissionId, audienceInsights } = action.payload
      return {
        ...state,
        brandConnectAudienceInsightsById: returnSecondIfDeepEqual(
          {
            ...state.brandConnectAudienceInsightsById,
            [submissionId]: audienceInsights,
          },
          state.brandConnectAudienceInsightsById,
        ),
        isFetching: false,
        errors: undefined,
      }
    }
    case AuthActionTypes.SIGNOUT_SUCCESS:
      return initialState
    default:
      return state
  }
}

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(applyAudienceInsightFilters, (state, action) => {
      // Override filters instead of merging
      state.filters = action.payload
    })
    .addDefaultCase(legacyReducer)
})

export { reducer as audienceInsightsReducer }
